var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart-button" }, [
    _vm.summary && _vm.summary.length > 0
      ? _c("div", { staticClass: "summary" }, [
          _c("i", { staticClass: "sd2-icons", class: _vm.summaryIcon }),
          _vm._v("\n    " + _vm._s(_vm.summary) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "booking-card" }, [
      _c("div", { staticClass: "price-summary" }, [
        _vm.showOriginalPrice
          ? _c("div", { staticClass: "original-price" }, [
              _c("span", { staticClass: "prepend" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("88401.DetailpageFromToPrice_RegularPriceLabel")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "price",
                domProps: {
                  innerHTML: _vm._s(_vm.pricing.original.price.toString()),
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "info pricing-info-icon",
                  on: {
                    click: function ($event) {
                      _vm.openPriceModal(
                        $event,
                        _vm.pricing.original.price.toString()
                      )
                    },
                  },
                },
                [_c("i", { staticClass: "sd2-icons info-outline" })]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", {
          staticClass: "price",
          domProps: { innerHTML: _vm._s(_vm.priceString) },
        }),
        _vm._v(" "),
        _vm.caption
          ? _c("div", { staticClass: "booking-info" }, [
              _vm._v("\n        " + _vm._s(_vm.caption) + "\n      "),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "booking-submit",
          class: { "sold-out": !_vm.isForSale },
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("submit")
            },
          },
        },
        [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }